import React, { useEffect, useRef } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'
import PollQuestion from './SmallComponents/PollQuestion'
import Floatingbutton from './Floatingbutton'
import Pollmodal from '../Modals/Pollmodal'
import ConformationPollmodal from '../Modals/Conformationpollmodal'
import config from '../../config'
import { connect } from 'react-redux'

function PollPage({ userAccess }) {
  const wideBlockRef = useRef()
  const [showModal, setShowModal] = React.useState(false)
  const [selectId, setSelectId] = React.useState(null)
  const [showConfirmModal, setShowConfirmModal] = React.useState(false)
  const [deleteId, setDeleteId] = React.useState(null)

  const [pollData, setPollData] = React.useState([])
  const [inputData, setInputData] = React.useState([])

  useEffect(() => {
    fetchmypolls()
  }, [])

  useEffect(() => {
    if (showModal) {
      fetchinputs()
    }
  }, [showModal])

  const fetchmypolls = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(config.apiUrl + '/post/Vote', {
        headers: { Authorization: token }
      })
      

      console.log('FULL API RESPONSE:', res.data.data)

      const normalized = (res.data.data || [])
        .map(post => ({
          pollId: post.ID,
          question: post.Data?.Question?.trim(),
          expiry: post.Data?.ExpiryDateTime || '',
          MySubmission: post?.MySubmission,
          Submissions: post?.Data?.Submissions,
          options: (post.Data?.Options || [])
            .filter(Boolean)
            .map((opt, index) => ({
              optionId: index,
              label: opt,
              votes: post?.Data?.Submissions ? (post.Data.Submissions[opt] ?? 0) : 0
            }))
        }))
        .filter(poll => poll.question && poll.options.length > 0)
        .sort((a, b) => b.pollId - a.pollId)
         console.log({normalized})
         setPollData(normalized)

      // setPollData(prevsetPoll => [...normalized,...prevsetPoll])
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch polls')
    }
  }

  useEffect(() => {
    const updateHeight = () => {
      const fullHeight = window.innerHeight
      const offset = 100 // adjust this based on your header or spacing
      if (wideBlockRef.current) {
        wideBlockRef.current.style.maxHeight = `${fullHeight - offset}px`
      }
    }

    updateHeight()
    window.addEventListener('resize', updateHeight)

    return () => window.removeEventListener('resize', updateHeight)
  }, [])

  console.log(userAccess)

  const handleSubmitPoll = async pollPayload => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.post(`${config.apiUrl}/post/Vote`, pollPayload, {
        headers: {
          Authorization: token,
          'Content-Type': 'application/json'
        }
      })

      toast.success('Poll created successfully!')
      setShowModal(false)

      const post = res.data?.data

      if (post) {
        const newPoll = {
          pollId: post.ID,
          question: post.Data?.Question || '',
          expiry: post.Data?.ExpiryDateTime || '',
          options: (post.Data?.Options || []).map((opt, index) => ({
            optionId: index,
            label: opt,
            votes: 0
          }))
        }

        if (
          newPoll.question &&
          newPoll.options &&
          newPoll.options.length >= 2
        ) {
          setPollData(prev => [newPoll, ...prev])
        } else {
          fetchmypolls() // fallback
        }
      }
    } catch (error) {
      console.error(error)
      toast.error(error.response?.data?.message || 'Failed to create poll')
    }
  }

  const handlemodalOpen = id => {
    setSelectId(id)
    setShowModal(true)
  }

  const handleDeleteModal = pollID => {
    setDeleteId(pollID)
    setShowConfirmModal(true)
  }

  const fetchinputs = async () => {
    const token = localStorage.getItem('token')

    try {
      const res = await axios.get(`${config.apiUrl}/projects/projects-with-wings`, {
        headers: { Authorization: token }
      })
       console.log('FULL API RESPONSE:', res.data)
       const normalized = (res.data || []).flatMap(project =>
       (project.Wings || []).map(wing => ({
        projectId:project.ID,
        projectName: project.Name.trim(),
        wingId: wing.ID,
        wingName: wing.Name
       }))
      ) 
      setInputData(normalized);
    } catch (err) {
      console.error(err)
      toast.error('Failed to fetch posts')
    }
  }


  const handleConfirmDelete = async () => {
  if (!deleteId) return;

  const token = localStorage.getItem('token');

  try {
    await axios.delete(`${config.apiUrl}/post/${deleteId}`, {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
    });

    setPollData(prev =>
      prev.filter(item => item.pollId !== deleteId)
    );

    toast.success('Poll deleted successfully!');
    setShowConfirmModal(false);
    setDeleteId(null);
  } catch (e) {
    console.error(e);
    toast.error('Failed to delete poll');
  }
};

  const handleCancelDelete = () => {
    setShowConfirmModal(false)
    setDeleteId(null)
  }

  return (
    <div id="appCapsule">
      <div class="section full mt-1">
        {/* <div class="section-title fw-bold fs-6">Updates</div> */}

        <div class="wide-block mt-1" ref={wideBlockRef}>
          {/* <!-- timeline --> */}
          <div className="timeline timed">
            {Array.isArray(pollData) &&
              pollData.map(item => (
                <div className="item" key={item.pollId}>
                  <span className="time">{item.expiry}</span>
                  <div className={`dot ${item.dotColor}`}></div>

                  <div className="content">
                    <div
                      className="card p-3 r position-relative"
                      style={{ backgroundColor: '#f1f1f1' }}
                    >
                      {userAccess.includes('DeleteVote') && (
                        <div
                          className="rounded-circle position-absolute top-0 end-0 p-2"
                          style={{
                            backgroundColor: 'red',
                            width: '56px',
                            height: '56px',
                            boxShadow: '0 2px 2px rgba(0,0,0,0.2)',
                            cursor: 'pointer',
                            zIndex: 10
                          }}
                          onClick={() => handleDeleteModal(item.pollId)}
                        >
                          <ion-icon
                            name="trash"
                            style={{
                              fontSize: '24px',
                              color: 'white',
                              cursor: 'pointer'
                            }}
                          />
                        </div>
                      )}

                      {item.question && item.options?.length > 0 && (
                        <PollQuestion
                          pollID={item.pollId}
                          question={item.question}
                          options={item.options}
                          MySubmission={item?.MySubmission?.Data?.SelectedOption}
                          onVoteSuccess={fetchmypolls}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
        {userAccess.includes('CreateVote') && (
          <Floatingbutton onOpen={handlemodalOpen} />
        )}
        
        <Pollmodal
          show={showModal}
          userId={selectId}
          onClose={() => setShowModal(false)}
          inputData={inputData}     
          fetchinputs={fetchinputs} 
          onSubmitPoll={handleSubmitPoll}
        />     
        <ConformationPollmodal
            show={showConfirmModal}
            onClose={handleCancelDelete}
            onConfirm={handleConfirmDelete}
        />
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth }) => {
  const { userAccess } = auth
  return {
    userAccess
  }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(PollPage)
